import { type OrderDetailsData } from 'legacy/routes/orders/details/OrderDetails.types'

export const getCurrentFromData = (data: OrderDetailsData) => {
  const { items, order } = data

  if (order && order.items_total) {
    return parseFloat(order.items_total)
  }

  return items.reduce((sum, item) => sum + parseFloat(item.current_charge || '0'), 0)
}

export const getInitialFromData = (data: OrderDetailsData) => {
  const { items, order } = data

  if (order && order.initial_items_total) {
    return parseFloat(order.initial_items_total)
  }

  return items.reduce((sum, item) => sum + parseFloat(item.initial_charge || '0'), 0)
}
